import React from 'react';
import HeaderMenuUser from './menu/HeaderMenuUser';
import HeaderMenuPerson from './menu/HeaderMenuPerson';
import HeaderRightSideUser from './menu/HeaderRightSideUser';
import HeaderRightSidePerson from './menu/HeaderRightSidePerson';
import UserMenu from './mobileMenu/MenuListUser';
import PersonMenu from './mobileMenu/MenuListPerson';

//объект, который отвечает за разделение роутинга по ролям в меню хедера и в мобильном меню
export const PERMISSIONMENU = {
    user: {
        menu: HeaderMenuUser,
        rightSide: HeaderRightSideUser,
        mobile: UserMenu
    },
    unautorized: {
        menu: HeaderMenuUser,
        rightSide: HeaderRightSideUser,
        mobile: UserMenu
    },
    person: {
        menu: HeaderMenuPerson,
        rightSide: HeaderRightSidePerson,
        mobile: PersonMenu
    }
}




// WEBPACK FOOTER //
// ./src/components/MenuComponents/getMenu.js